import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function LabeledValueLineSkeleton() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Skeleton variant="text" width={120} height={16} />
            <Skeleton variant="text" width="60%" height={20} />
        </Box>
    );
}

function OrderInfoSkeleton() {
    return (
        <div className="col-xs-12 col-md-7 col-lg-8">
            <div className="col-xs-12 col-lg-6">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <Skeleton variant="text" width={160} height={24} />
                    </div>
                    <div className="panel-body">
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <LabeledValueLineSkeleton />
                            <LabeledValueLineSkeleton />
                            <div className="row">
                                <div className="col-sm-6">
                                    <LabeledValueLineSkeleton />
                                </div>
                                <div className="col-sm-6">
                                    <LabeledValueLineSkeleton />
                                </div>
                            </div>
                            <Skeleton variant="rectangular" width="50%" height={34} />
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderInfoSkeleton;
